export const MEDIA_KIT_MIN_GRADUATION_YEAR = 1900;
export const MEDIA_KIT_MAX_GRADUATION_YEAR_FUTURE_OFFSET = 5;

export const MEDIA_KIT_MAX_PHOTOS = 4;
export const MEDIA_KIT_MAX_ABOUT_CHARS = 700;
export const MEDIA_KIT_MAX_HIGHLIGHT_TITLE_CHARS = 50;
export const MEDIA_KIT_MAX_HIGHLIGHT_DESCRIPTION_CHARS = 250;
export const MEDIA_KIT_MAX_HIGHLIGHT_IMPACT_CHARS = 250;

export function getMediaKitMaxGraduationYear(referenceDate = new Date()): number {
    return referenceDate.getFullYear() + MEDIA_KIT_MAX_GRADUATION_YEAR_FUTURE_OFFSET;
}

export function validateMediaKitGraduationYear(raw: string): string | null {
    const trimmed = raw.trim();
    if (!trimmed) {
        return 'Graduation year is required.';
    }
    if (!/^\d{4}$/.test(trimmed)) {
        return 'Graduation year must be a four-digit year.';
    }
    const year = parseInt(trimmed, 10);
    const maxYear = getMediaKitMaxGraduationYear();
    if (year < MEDIA_KIT_MIN_GRADUATION_YEAR) {
        return `Graduation year must be ${MEDIA_KIT_MIN_GRADUATION_YEAR} or later.`;
    }
    if (year > maxYear) {
        return `Graduation year cannot be more than ${MEDIA_KIT_MAX_GRADUATION_YEAR_FUTURE_OFFSET} years in the future.`;
    }
    return null;
}

export function truncateMediaKitField(value: string, maxLength: number): string {
    return value.slice(0, maxLength);
}

export function validateMediaKitAbout(aboutYou: string): string | null {
    if (aboutYou.length > MEDIA_KIT_MAX_ABOUT_CHARS) {
        return `About you must be ${MEDIA_KIT_MAX_ABOUT_CHARS} characters or fewer.`;
    }
    return null;
}

export function validateMediaKitHighlightFields(
    title: string,
    description: string,
    impact: string,
): string | null {
    const hasContent = [title, description, impact].some((value) => value.trim().length > 0);
    if (!hasContent) {
        return null;
    }
    if (title.trim().length > MEDIA_KIT_MAX_HIGHLIGHT_TITLE_CHARS) {
        return `Title must be ${MEDIA_KIT_MAX_HIGHLIGHT_TITLE_CHARS} characters or fewer.`;
    }
    if (description.trim().length > MEDIA_KIT_MAX_HIGHLIGHT_DESCRIPTION_CHARS) {
        return `Description must be ${MEDIA_KIT_MAX_HIGHLIGHT_DESCRIPTION_CHARS} characters or fewer.`;
    }
    if (impact.trim().length > MEDIA_KIT_MAX_HIGHLIGHT_IMPACT_CHARS) {
        return `Impact must be ${MEDIA_KIT_MAX_HIGHLIGHT_IMPACT_CHARS} characters or fewer.`;
    }
    return null;
}
